import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

/**
 * Atomically reserve an auction for Buy It Now purchase and create the
 * pending_payment order. Server-authoritative: the price is read from the
 * auction row inside the RPC — the client cannot influence it.
 *
 * Returns the order id and reservation expiry. Client then sets shipping and
 * calls createCheckoutSession to redirect to Stripe.
 */
export const startBuyNowPurchase = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d) =>
    z.object({ auctionId: z.string().uuid() }).parse(d),
  )
  .handler(async ({ data, context }) => {
    const { data: res, error } = await context.supabase.rpc(
      "start_buy_now_purchase" as never,
      { _auction_id: data.auctionId } as never,
    );
    if (error) throw new Error(error.message);
    return res as {
      order_id: string;
      auction_id: string;
      buy_now_price_pence: number;
      reservation_expires_at: string;
      reused: boolean;
    };
  });
